import { render, staticRenderFns } from "./crudPriceListSuppliers.vue?vue&type=template&id=e628ef62&scoped=true&"
import script from "./crudPriceListSuppliers.vue?vue&type=script&lang=js&"
export * from "./crudPriceListSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./crudPriceListSuppliers.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudPriceListSuppliers.vue?vue&type=style&index=1&id=e628ef62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e628ef62",
  null
  
)

export default component.exports